import styled, {css, DefaultTheme} from 'styled-components'
import {ProjectIndex} from '@/features/projects/types.ts'

const getStatusColor = (status: NonNullable<ProjectIndex['status']>, palette: DefaultTheme['palette']) => {
    const statusToColors = {
        closed: palette.red['500'],
        open: palette.green['500'],
        opening: palette.orange['500']
    } as const satisfies Record<NonNullable<ProjectIndex['status']>, string>

    return statusToColors[status]
}

export const StyledStatusBullet = styled.span<{$status: ProjectIndex['status']}>(
    ({theme: {palette, opacities}, $status}) => css`
        width: 8px;
        height: 8px;
        border-radius: 2px;
        border: 1px solid ${palette.neutral.black}${opacities['10']};
        background-color: ${$status ? getStatusColor($status, palette) : 'transparent'};
    `
)
